import { useConsent } from "@/context/ConsentContext";
import { api } from "@/lib/api-client";
import { useEffect } from "react";

// Mounted only once the user is authenticated: pulls the authoritative consent
// snapshot from the DB and reconciles it with the local decision (push a changed
// local choice up, or adopt the DB decision when the browser has none).
export function ConsentReconciler() {
  const { reconcileWithServer } = useConsent();
  const { data, isError } = api.consent.useGetConsent();

  useEffect(() => {
    if (data !== undefined) reconcileWithServer(data);
    else if (isError) reconcileWithServer(null);
  }, [data, isError, reconcileWithServer]);

  return null;
}
